// @ts-check
// Nome por extenso de um fuso para quem lê (pura; Worker, Durable Object, SPA e página pública): "Horário de Brasília"
// em vez de "America/Sao_Paulo". Vem do Intl no idioma pedido; o "Padrão" que o Intl põe nos fusos sem horário de
// verão (o Brasil não tem desde 2019) sai, porque a escola fala "horário de Brasília". Sem nome no Intl (ou só "GMT"),
// vira "Horário de <cidade>" a partir do identificador.

const STANDARD_WORD = /^Horário Padrão (d[aeo]s? )/;

/**
 * @param {string} timeZone identificador IANA (America/Sao_Paulo)
 * @param {{ locale?: string, at?: Date }} [options]
 * @returns {string}
 */
export function timeZoneDisplayName(timeZone, options = {}) {
  const locale = options.locale ?? 'pt-BR';
  const at = options.at ?? new Date();
  const fallback = `Horário de ${String(timeZone ?? '').split('/').pop()?.replace(/_/g, ' ') || timeZone}`;
  if (typeof timeZone !== 'string' || timeZone === '') return fallback;
  try {
    const name = new Intl.DateTimeFormat(locale, { timeZone, timeZoneName: 'longGeneric' }).formatToParts(at)
      .find((part) => part.type === 'timeZoneName')?.value ?? '';
    if (!name || /^(GMT|UTC)([+-]|$)/.test(name)) return fallback;
    return name.replace(STANDARD_WORD, 'Horário $1');
  } catch {
    return fallback;
  }
}

/**
 * O mesmo nome para o meio de uma frase ("Os horários seguem o horário de Brasília.").
 * @param {string} timeZone @param {{ locale?: string, at?: Date }} [options]
 */
export function timeZoneNameInSentence(timeZone, options = {}) {
  const name = timeZoneDisplayName(timeZone, options);
  return name.charAt(0).toLocaleLowerCase(options.locale ?? 'pt-BR') + name.slice(1);
}
